import React from 'react';
import { useNavigate } from 'react-router-dom';

import HeaderUno from '../../Metodos/Compartidos/HeaderUno.js';

import {
    Cuerpo
} from '../../Css/StyledHeader.js';

import {
    HeaderTutorialesFijo,
    EspacioHeaderTutoriales
} from '../../Css/StyledTutoriales.js';

import {
    ManualMain,
    ManualVolver,

    ManualCabecera,
    ManualBadge,
    ManualTitulo,
    ManualBajada,
    ManualIntroduccion,

    ManualIndice,
    ManualIndiceTitulo,
    ManualIndiceGrid,
    ManualIndiceItem,
    ManualIndiceNumero,
    ManualIndiceTexto,

    ManualCapitulo,
    ManualCapituloNumero,
    ManualCapituloTitulo,
    ManualSubtitulo,
    ManualTexto,

    ManualPasos,
    ManualPaso,
    ManualPasoNumero,
    ManualPasoTexto,

    ManualClave,
    ManualImportante,
    ManualAdvertencia,

    ManualEjemplo,
    ManualEjemploTitulo,
    ManualEjemploFila,

    ManualDefiniciones,
    ManualDefinicion,
    ManualDefinicionTitulo,
    ManualDefinicionTexto,

    ManualCaso,
    ManualCasoPregunta,
    ManualCasoRespuesta,

    ManualResumen,
    ManualResumenFila,
    ManualResumenProblema,
    ManualResumenAccion,

    ManualImagen,
    ManualImagenPie,

    ManualSeparador
} from '../../Css/StyledManualCobros.js';


/*
====================================
MANUAL CENTROS Y LIQUIDACIONES
====================================
*/

const ManualCobrosCentros = () => {

    const navigate =
        useNavigate();


    /*
    ====================================
    IR A SECCIÓN
    ====================================
    */

    const irASeccion = (
        id
    ) => {

        const elemento =
            document.getElementById(
                id
            );

        if (
            !elemento
        ) {

            return;

        }

        elemento.scrollIntoView({
            behavior:
                'smooth',

            block:
                'start'
        });

    };


    /*
    ====================================
    ÍNDICE
    ====================================
    */

    const indice = [

        {
            id:
                'para-que-sirve',

            numero:
                '1',

            titulo:
                'Para qué sirve Centros y liquidaciones'
        },

        {
            id:
                'crear-centro',

            numero:
                '2',

            titulo:
                'Cómo crear un centro'
        },

        {
            id:
                'condiciones-generales',

            numero:
                '3',

            titulo:
                'Cómo configurar las condiciones generales'
        },

        {
            id:
                'prestaciones-pagan',

            numero:
                '4',

            titulo:
                'Qué prestaciones pagan al centro'
        },

        {
            id:
                'tipo-honorario',

            numero:
                '5',

            titulo:
                'Cómo se calcula el honorario'
        },

        {
            id:
                'prestacion-vs-cobro',

            numero:
                '6',

            titulo:
                'Diferencia entre Prestación y Cobro'
        },

        {
            id:
                'condiciones-mensuales',

            numero:
                '7',

            titulo:
                'Cómo funcionan las condiciones mensuales'
        },

        {
            id:
                'vencimiento',

            numero:
                '8',

            titulo:
                'Cómo configurar el vencimiento'
        },

        {
            id:
                'vincular-paciente',

            numero:
                '9',

            titulo:
                'Cómo vincular un paciente al centro'
        },

        {
            id:
                'condiciones-paciente',

            numero:
                '10',

            titulo:
                'General, Particular y Mixta'
        },

        {
            id:
                'finalizar-vinculo',

            numero:
                '11',

            titulo:
                'Cómo finalizar un vínculo'
        },

        {
            id:
                'leer-liquidacion',

            numero:
                '12',

            titulo:
                'Cómo leer Corresponde, Pagado, Pendiente y Esperando cobro'
        },

        {
            id:
                'posicion-centro',

            numero:
                '13',

            titulo:
                'Cómo leer la Posición del centro'
        },

        {
            id:
                'detalle-prestaciones',

            numero:
                '14',

            titulo:
                'Cómo revisar prestaciones y mensualidades'
        },

        {
            id:
                'condicion-prestacion',

            numero:
                '15',

            titulo:
                'Pagar o No pagar una prestación al centro'
        },

        {
            id:
                'registrar-pago',

            numero:
                '16',

            titulo:
                'Cómo registrar un pago al centro'
        },

        {
            id:
                'historial-pagos',

            numero:
                '17',

            titulo:
                'Historial de pagos y anulaciones'
        },

        {
            id:
                'casos-frecuentes',

            numero:
                '18',

            titulo:
                'Casos frecuentes'
        },

        {
            id:
                'resumen-rapido',

            numero:
                '19',

            titulo:
                'Resumen rápido'
        }

    ];


    /*
    ====================================
    VOLVER AL ÍNDICE
    ====================================
    */

    const renderVolverIndice = () => (

        <ManualVolver
            type="button"

            onClick={() =>
                irASeccion(
                    'indice'
                )
            }
        >
            ↑ Volver al índice
        </ManualVolver>

    );


    /*
    ====================================
    RENDER
    ====================================
    */

    return (

        <Cuerpo>

            <HeaderTutorialesFijo>

                <HeaderUno />

            </HeaderTutorialesFijo>

            <EspacioHeaderTutoriales />


            <ManualMain>


                {/*
                ====================================
                VOLVER A TUTORIALES
                ====================================
                */}

                <ManualVolver
                    type="button"

                    onClick={() =>
                        navigate(
                            '/escritorio/tutoriales'
                        )
                    }
                >
                    ← Volver a Tutoriales
                </ManualVolver>


                {/*
                ====================================
                CABECERA
                ====================================
                */}

                <ManualCabecera>

                    <ManualBadge>
                        Guía paso a paso
                    </ManualBadge>


                    <ManualTitulo>
                        Centros y liquidaciones
                    </ManualTitulo>


                    <ManualBajada>
                        Cómo configurar las condiciones económicas
                        de cada centro, vincular pacientes,
                        calcular lo que corresponde pagar,
                        controlar pendientes y registrar
                        los pagos realizados al centro.
                    </ManualBajada>

                </ManualCabecera>


                <ManualIntroduccion>

                    <p>
                        Esta guía explica el circuito completo
                        de <strong>Centros y liquidaciones</strong>.
                        Podés leerla de principio a fin la primera
                        vez y después utilizar el índice para ir
                        directamente al tema que necesites.
                    </p>

                </ManualIntroduccion>


                {/*
                ====================================
                ÍNDICE
                ====================================
                */}

                <ManualIndice id="indice">

                    <ManualIndiceTitulo>
                        Índice
                    </ManualIndiceTitulo>


                    <ManualIndiceGrid>

                        {
                            indice.map(
                                (
                                    item
                                ) => (

                                    <ManualIndiceItem
                                        key={
                                            item.id
                                        }

                                        type="button"

                                        onClick={() =>
                                            irASeccion(
                                                item.id
                                            )
                                        }
                                    >

                                        <ManualIndiceNumero>
                                            {item.numero}
                                        </ManualIndiceNumero>

                                        <ManualIndiceTexto>
                                            {item.titulo}
                                        </ManualIndiceTexto>

                                    </ManualIndiceItem>

                                )
                            )
                        }

                    </ManualIndiceGrid>

                </ManualIndice>


                {/*
                ====================================
                CAPÍTULO 1
                ====================================
                */}

                <ManualCapitulo
                    id="para-que-sirve"
                >

                    <ManualCapituloNumero>
                        Capítulo 1
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Para qué sirve Centros y liquidaciones
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        La sección
                        <strong> Centros y liquidaciones</strong>
                        sirve para llevar el seguimiento económico
                        de los centros con los que trabajás.
                    </ManualTexto>


                    <ManualTexto>
                        La plataforma permite definir cómo se
                        calcula lo que corresponde al centro,
                        qué prestaciones se incluyen, cuándo
                        se genera ese importe, cuándo vence y
                        qué pacientes están vinculados.
                    </ManualTexto>


                    <ManualTexto>
                        Después, la misma pantalla permite
                        comparar lo que
                        <strong> Corresponde</strong>,
                        lo que ya fue
                        <strong> Pagado</strong>,
                        lo que continúa
                        <strong> Pendiente</strong>
                        y lo que todavía está
                        <strong> Esperando cobro</strong>
                        del paciente.
                    </ManualTexto>

                    <ManualImagen $ancho="grande">

                        <img
                            src="/img/tutoriales/cobros-centros/01-centros-liquidaciones-general.png"
                            alt="Pantalla general de Centros y liquidaciones"
                        />

                        <ManualImagenPie>
                            Pantalla principal de Centros y liquidaciones.
                            Desde acá podés seleccionar un centro, revisar su
                            situación económica y acceder a sus distintas acciones.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualClave>
                        <strong>Idea clave:</strong> esta pantalla
                        no reemplaza los cobros de los pacientes.
                        Organiza una cuenta diferente:
                        <strong>
                            {' '}
                            cuánto corresponde pagarle al centro.
                        </strong>
                    </ManualClave>


                    <ManualTexto>
                        Por eso existen dos circuitos relacionados
                        pero distintos:
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Pacientes
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Registra lo que el paciente debe,
                                lo que pagó y su saldo.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Centros y liquidaciones
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Calcula y controla lo que
                                corresponde pagar al centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 2
                ====================================
                */}

                <ManualCapitulo
                    id="crear-centro"
                >

                    <ManualCapituloNumero>
                        Capítulo 2
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo crear un centro
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Para comenzar a trabajar con un centro,
                        primero tenés que crearlo y definir
                        sus condiciones económicas iniciales.
                    </ManualTexto>


                    <ManualPasos>

                        <ManualPaso>

                            <ManualPasoNumero>
                                1
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Entrá en
                                <strong>
                                    {' '}
                                    Estadísticas y cobros
                                </strong>
                                y abrí la solapa
                                <strong>
                                    {' '}
                                    Centros y liquidaciones
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                2
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong>
                                    {' '}
                                    + Agregar centro
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>
                        

                        <ManualPaso>

                            <ManualPasoNumero>
                                3
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                En la sección
                                <strong> Centro</strong>,
                                completá
                                <strong> Nombre</strong>
                                y
                                <strong> Vigente desde</strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                4
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Si lo necesitás, completá
                                <strong>
                                    {' '}
                                    Descripción opcional
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                5
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Configurá la
                                <strong>
                                    {' '}
                                    Condición económica
                                </strong>,
                                las prestaciones que pagan al centro
                                y la
                                <strong>
                                    {' '}
                                    Forma habitual de liquidación
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                6
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong>
                                    {' '}
                                    Guardar centro
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>

                    </ManualPasos>

                    <ManualImagen $ancho="medio">

                        <img
                            src="/img/tutoriales/cobros-centros/03-agregar-centro.png"
                            alt="Pantalla Agregar centro"
                        />

                        <ManualImagenPie>
                            Al crear un centro definís sus datos básicos,
                            la condición económica, qué prestaciones pagan
                            al centro y la forma habitual de liquidación.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualImportante>
                        <strong>Vigente desde</strong> indica
                        desde qué fecha comienza a aplicarse
                        esta configuración económica.
                    </ManualImportante>


                    <ManualClave>
                        No hace falta crear un centro diferente
                        cada vez que cambian sus condiciones.
                        Más adelante podés crear una nueva
                        versión desde
                        <strong> Condiciones generales</strong>.
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 3
                ====================================
                */}

                <ManualCapitulo
                    id="condiciones-generales"
                >

                    <ManualCapituloNumero>
                        Capítulo 3
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo configurar las condiciones generales
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Cada centro tiene
                        <strong> Condiciones generales</strong>.
                        Son las reglas económicas que utilizan
                        los pacientes vinculados al centro,
                        salvo que algún paciente tenga una
                        excepción particular.
                    </ManualTexto>


                    <ManualTexto>
                        Cuando necesitás modificar esas reglas,
                        no se reemplaza el historial anterior.
                        Se crea una nueva configuración indicando
                        desde qué fecha comienza a regir.
                    </ManualTexto>


                    <ManualClave>
                        <strong>Esto es importante:</strong>
                        una nueva configuración no cambia
                        retroactivamente las prestaciones que
                        utilizaron una condición anterior.
                    </ManualClave>

                    <ManualImagen $ancho="medio">

                        <img
                            src="/img/tutoriales/cobros-centros/04-condiciones-generales.png"
                            alt="Condiciones generales del centro"
                        />

                        <ManualImagenPie>
                            Desde Condiciones generales podés crear una nueva
                            configuración con su propia fecha de vigencia
                            y conservar las configuraciones anteriores.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualTexto>
                        Dentro de
                        <strong> Condiciones generales</strong>
                        también aparece el
                        <strong>
                            {' '}
                            Historial de configuraciones
                        </strong>,
                        para poder revisar las distintas
                        versiones que tuvo el centro.
                    </ManualTexto>


                    <ManualPasos>

                        <ManualPaso>

                            <ManualPasoNumero>
                                1
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Seleccioná el centro que querés
                                modificar.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                2
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Abrí
                                <strong>
                                    {' '}
                                    Condiciones generales
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                3
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Indicá la nueva fecha
                                <strong>
                                    {' '}
                                    Vigente desde
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                4
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Modificá las condiciones que
                                correspondan.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                5
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong>
                                    {' '}
                                    Guardar nueva configuración
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>

                    </ManualPasos>


                    <ManualImportante>
                        La nueva configuración debe comenzar
                        en la fecha actual o en una fecha futura.
                        No se utiliza esta pantalla para
                        modificar retroactivamente una versión
                        histórica.
                    </ManualImportante>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 4
                ====================================
                */}

                <ManualCapitulo
                    id="prestaciones-pagan"
                >

                    <ManualCapituloNumero>
                        Capítulo 4
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Qué prestaciones pagan al centro
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Dentro de la configuración aparece
                        la sección
                        <strong>
                            {' '}
                            Qué prestaciones pagan al centro
                        </strong>.
                    </ManualTexto>


                    <ManualTexto>
                        Allí podés definir qué tipos de eventos
                        generan normalmente un honorario para
                        el centro.
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Sesión con paciente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Marcala si las sesiones con
                                pacientes deben generar lo que
                                corresponde al centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Reunión con padres
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Marcala si este tipo de reunión
                                también debe liquidarse al centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Reunión con colegio
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Define si este tipo de prestación
                                paga honorario al centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Reunión con profesionales
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Define si estas reuniones
                                forman parte de la liquidación
                                del centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualClave>
                        Esta es la
                        <strong> regla general</strong>.
                        Más adelante podés cambiar la condición
                        de una prestación individual utilizando
                        <strong>
                            {' '}
                            Usar condición original
                        </strong>,
                        <strong>
                            {' '}
                            Pagar esta prestación
                        </strong>
                        o
                        <strong>
                            {' '}
                            No pagar esta prestación
                        </strong>.
                        La opción original mostrará entre paréntesis
                        si para esa prestación correspondía
                        <strong> Pagar</strong> o
                        <strong> No pagar</strong>.
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 5
                ====================================
                */}

                <ManualCapitulo
                    id="tipo-honorario"
                >

                    <ManualCapituloNumero>
                        Capítulo 5
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo se calcula el honorario
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        En
                        <strong> Condición económica</strong>,
                        el campo
                        <strong> Tipo de fee</strong>
                        define cómo se calcula lo que
                        corresponde pagar al centro.
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Porcentaje
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El honorario del centro se calcula
                                como un porcentaje.
                                Por ejemplo, un 30%.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Importe fijo por prestación
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El centro recibe un importe
                                fijo por cada prestación que
                                corresponda pagar.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Importe fijo mensual
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Se establece un importe mensual
                                por paciente según la condición
                                mensual elegida.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo de porcentaje
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>

                            <span>
                                Honorarios de la prestación
                            </span>

                            <strong>
                                $10.000
                            </strong>

                        </ManualEjemploFila>


                        <ManualEjemploFila>

                            <span>
                                Porcentaje del centro
                            </span>

                            <strong>
                                30%
                            </strong>

                        </ManualEjemploFila>


                        <ManualEjemploFila>

                            <span>
                                Corresponde al centro
                            </span>

                            <strong>
                                $3.000
                            </strong>

                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualClave>
                        El
                        <strong> Tipo de fee</strong>
                        responde a la pregunta:
                        <strong>
                            {' '}
                            “¿Cómo calculamos cuánto corresponde?”
                        </strong>
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 6
                ====================================
                */}

                <ManualCapitulo
                    id="prestacion-vs-cobro"
                >

                    <ManualCapituloNumero>
                        Capítulo 6
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Diferencia entre Prestación y Cobro
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Cuando el
                        <strong> Tipo de fee</strong>
                        es
                        <strong> Porcentaje</strong>
                        o
                        <strong>
                            {' '}
                            Importe fijo por prestación
                        </strong>,
                        aparece la pregunta:
                    </ManualTexto>


                    <ManualClave>
                        <strong>
                            ¿Cuándo se genera lo que corresponde
                            al centro?
                        </strong>
                    </ManualClave>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Cuando realizo la prestación
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                La obligación con el centro
                                se genera a partir de la
                                prestación realizada,
                                aunque el paciente todavía
                                no la haya pagado.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Cuando recibo el pago del paciente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Lo que corresponde al centro
                                depende del cobro registrado
                                al paciente.
                                Mientras todavía no corresponda
                                generarlo, puede aparecer como
                                <strong>
                                    {' '}
                                    Esperando cobro
                                </strong>.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>

                            <span>
                                Prestación
                            </span>

                            <strong>
                                $10.000
                            </strong>

                        </ManualEjemploFila>


                        <ManualEjemploFila>

                            <span>
                                Porcentaje
                            </span>

                            <strong>
                                30%
                            </strong>

                        </ManualEjemploFila>


                        <ManualEjemploFila>

                            <span>
                                Base: Cuando realizo la prestación
                            </span>

                            <strong>
                                $3.000 corresponde al realizarla
                            </strong>

                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualImportante>
                        <strong>Prestación</strong> y
                        <strong> Cobro</strong>
                        no indican cómo se calcula el monto.
                        Indican
                        <strong>
                            {' '}
                            cuándo corresponde generarlo.
                        </strong>
                    </ManualImportante>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 7
                ====================================
                */}

                <ManualCapitulo
                    id="condiciones-mensuales"
                >

                    <ManualCapituloNumero>
                        Capítulo 7
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo funcionan las condiciones mensuales
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Si elegís
                        <strong>
                            {' '}
                            Importe fijo mensual
                        </strong>,
                        en lugar de elegir Prestación o Cobro
                        aparece:
                    </ManualTexto>


                    <ManualClave>
                        <strong>
                            ¿Cuándo corresponde generar
                            el monto mensual?
                        </strong>
                    </ManualClave>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Si hubo prestaciones durante el mes
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El importe mensual corresponde
                                cuando el paciente tuvo al menos
                                una prestación que paga al centro
                                durante ese mes.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Si el paciente estuvo vinculado al centro
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El importe mensual corresponde
                                por la vigencia de la vinculación,
                                aunque ese mes no tenga prestaciones.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Si hubo cobros del paciente durante el mes
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El importe mensual corresponde
                                cuando se registra el cobro
                                del paciente que activa esa
                                mensualidad.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>

                    <ManualImagen $ancho="grande">

                        <img
                            src="/img/tutoriales/cobros-centros/07-detalle-mensualidades.png"
                            alt="Detalle de una liquidación mensual"
                        />

                        <ManualImagenPie>
                            Cuando la condición es un importe fijo mensual,
                            el detalle permite identificar el mes,
                            el vencimiento, el importe que corresponde,
                            lo pagado y lo pendiente.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualImportante>
                        El
                        <strong>
                            {' '}
                            Importe fijo mensual
                        </strong>
                        corresponde una sola vez por paciente
                        y por mes cuando se cumple la condición.
                        No se multiplica por la cantidad de
                        prestaciones del mes.
                    </ManualImportante>


                    <ManualTexto>
                        En el
                        <strong>
                            {' '}
                            Detalle de prestaciones
                        </strong>,
                        cuando existen varias prestaciones
                        correspondientes a la misma mensualidad,
                        las adicionales pueden aparecer como
                        <strong>
                            {' '}
                            Incluida en mensualidad
                        </strong>.
                    </ManualTexto>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 8
                ====================================
                */}

                <ManualCapitulo
                    id="vencimiento"
                >

                    <ManualCapituloNumero>
                        Capítulo 8
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo configurar el vencimiento
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        En
                        <strong>
                            {' '}
                            Forma habitual de liquidación
                        </strong>
                        aparece el campo
                        <strong> Vencimiento</strong>.
                    </ManualTexto>


                    <ManualTexto>
                        Este dato establece la fecha de
                        vencimiento de las obligaciones que
                        se generan para el centro.
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Inmediato
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                La obligación vence en la misma
                                fecha en la que se genera.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Fin del mismo mes
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El vencimiento queda en el
                                último día de ese mismo mes.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Fin del mes siguiente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El vencimiento queda en el
                                último día del mes siguiente.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Día específico del mes siguiente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Podés indicar un
                                <strong> Día</strong>
                                determinado del mes siguiente.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>

                            <span>
                                Fecha de la prestación
                            </span>

                            <strong>
                                17/12/2026
                            </strong>

                        </ManualEjemploFila>


                        <ManualEjemploFila>

                            <span>
                                Vencimiento configurado
                            </span>

                            <strong>
                                Día 10 del mes siguiente
                            </strong>

                        </ManualEjemploFila>


                        <ManualEjemploFila>

                            <span>
                                Fecha de vencimiento
                            </span>

                            <strong>
                                10/01/2027
                            </strong>

                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualClave>
                        La fecha de
                        <strong> Vencimiento</strong>
                        también puede verse después en el
                        <strong>
                            {' '}
                            Detalle de prestaciones
                        </strong>.
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 9
                ====================================
                */}

                <ManualCapitulo
                    id="vincular-paciente"
                >

                    <ManualCapituloNumero>
                        Capítulo 9
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo vincular un paciente al centro
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Crear un centro no significa que todos
                        tus pacientes pertenezcan a ese centro.
                        Los pacientes deben vincularse.
                    </ManualTexto>


                    <ManualPasos>

                        <ManualPaso>

                            <ManualPasoNumero>
                                1
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Seleccioná el centro.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                2
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong>
                                    {' '}
                                    Vincular paciente
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                3
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                En
                                <strong> Paciente</strong>,
                                elegí el paciente que querés
                                asignar.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                4
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Completá
                                <strong>
                                    {' '}
                                    Vigente desde
                                </strong>
                                con la fecha a partir de la
                                cual pertenece al centro.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                5
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong>
                                    {' '}
                                    Vincular paciente
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>

                    </ManualPasos>

                    <ManualImagen $ancho="medio">

                        <img
                            src="/img/tutoriales/cobros-centros/11-vincular-paciente.png"
                            alt="Pantalla Vincular paciente"
                        />

                        <ManualImagenPie>
                            Desde Vincular paciente indicás desde qué fecha
                            comienza la vinculación. El paciente utilizará
                            inicialmente las condiciones económicas generales
                            del centro.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualClave>
                        Al vincularlo, el paciente utiliza
                        inicialmente las
                        <strong>
                            {' '}
                            condiciones económicas generales
                            del centro
                        </strong>.
                    </ManualClave>


                    <ManualTexto>
                        Si ese paciente necesita una excepción,
                        después podés utilizar
                        <strong> Configurar</strong>
                        para crear condiciones particulares.
                    </ManualTexto>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 10
                ====================================
                */}

                <ManualCapitulo
                    id="condiciones-paciente"
                >

                    <ManualCapituloNumero>
                        Capítulo 10
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        General, Particular y Mixta
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        En el resumen de pacientes del centro
                        aparece una etiqueta en la columna
                        <strong> Condición</strong>.
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                General
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El paciente utiliza las
                                condiciones generales definidas
                                para el centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                        
                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Particular
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El paciente tiene una o más
                                condiciones propias que se
                                diferencian de las generales
                                del centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Mixta
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                En el historial del vínculo
                                existen períodos con condiciones
                                generales y períodos con
                                condiciones particulares.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>

                    <ManualImagen $ancho="medio">

                        <img
                            src="/img/tutoriales/cobros-centros/09-excepcion-paciente.png"
                            alt="Excepción económica de un paciente"
                        />

                        <ManualImagenPie>
                            Una condición particular permite establecer
                            excepciones para un paciente sin modificar
                            las condiciones generales del centro.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualImportante>
                        <strong>Mixta</strong> es una forma
                        de mostrar el historial del paciente.
                        No es una tercera opción que tengas
                        que seleccionar dentro de
                        <strong>
                            {' '}
                            Condiciones del paciente
                        </strong>.
                    </ManualImportante>


                    <ManualSubtitulo>
                        Condiciones del paciente
                    </ManualSubtitulo>


                    <ManualTexto>
                        Al hacer clic en
                        <strong> Configurar</strong>,
                        se abre
                        <strong>
                            {' '}
                            Condiciones del paciente
                        </strong>.
                    </ManualTexto>


                    <ManualTexto>
                        Allí podés indicar
                        <strong> Vigente desde</strong>
                        y elegir en
                        <strong> Tipo de condición</strong>:
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Condiciones generales
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El paciente hereda las reglas
                                generales vigentes del centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Condiciones particulares
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Permite establecer excepciones
                                específicas para ese paciente.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>

                    <ManualImagen $ancho="medio">

                        <img
                            src="/img/tutoriales/cobros-centros/05-condiciones-paciente.png"
                            alt="Condiciones particulares de un paciente"
                        />

                        <ManualImagenPie>
                            Desde Condiciones del paciente podés decidir
                            desde qué fecha utiliza las condiciones generales
                            o condiciones particulares.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualClave>
                        Si más adelante volvés a seleccionar
                        <strong>
                            {' '}
                            Condiciones generales
                        </strong>,
                        desde esa fecha el paciente vuelve
                        a heredar automáticamente las
                        condiciones generales del centro.
                    </ManualClave>


                    <ManualTexto>
                        Los períodos anteriores conservan
                        las condiciones que correspondían
                        en ese momento.
                    </ManualTexto>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 11
                ====================================
                */}

                <ManualCapitulo
                    id="finalizar-vinculo"
                >

                    <ManualCapituloNumero>
                        Capítulo 11
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo finalizar un vínculo
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Si un paciente deja de pertenecer
                        a un centro, no necesitás eliminar
                        su información histórica.
                    </ManualTexto>


                    <ManualTexto>
                        Utilizá el botón
                        <strong>
                            {' '}
                            Finalizar vínculo
                        </strong>.
                    </ManualTexto>


                    <ManualPasos>

                        <ManualPaso>

                            <ManualPasoNumero>
                                1
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Buscá al paciente dentro
                                del centro.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                2
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong>
                                    {' '}
                                    Finalizar vínculo
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                3
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Indicá hasta qué fecha estuvo
                                vigente la vinculación.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                4
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Confirmá con
                                <strong>
                                    {' '}
                                    Finalizar vínculo
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>

                    </ManualPasos>

                    <ManualImagen $ancho="medio">

                        <img
                            src="/img/tutoriales/cobros-centros/12-finalizar-vinculo.png"
                            alt="Pantalla Finalizar vínculo"
                        />

                        <ManualImagenPie>
                            Al finalizar un vínculo indicás hasta qué fecha
                            estuvo vigente la relación del paciente con el centro.
                            La información histórica se conserva.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualClave>
                        Finalizar el vínculo registra la fecha
                        de finalización y
                        <strong>
                            {' '}
                            conserva el historial anterior.
                        </strong>
                    </ManualClave>


                    <ManualImportante>
                        La fecha de finalización no puede ser
                        anterior a la fecha desde la que comenzó
                        esa vinculación.
                    </ManualImportante>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 12
                ====================================
                */}

                <ManualCapitulo
                    id="leer-liquidacion"
                >

                    <ManualCapituloNumero>
                        Capítulo 12
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo leer Corresponde, Pagado,
                        Pendiente y Esperando cobro
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        En
                        <strong> Resumen por centro</strong>
                        aparecen cuatro datos económicos
                        principales.
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Corresponde
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es el importe que corresponde
                                al centro según las reglas
                                económicas aplicables en el
                                período seleccionado.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Pagado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es cuánto de las obligaciones
                                correspondientes a ese período
                                ya fue cubierto con pagos
                                realizados al centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Pendiente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es la parte de lo que corresponde
                                al centro que todavía permanece
                                pendiente de pago.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Esperando cobro
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es un importe que todavía
                                depende del cobro al paciente
                                porque la condición económica
                                está basada en
                                <strong> Cobro</strong>.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>

                    <ManualImagen $ancho="grande">

                        <img
                            src="/img/tutoriales/cobros-centros/02-resumen-centro-y-pacientes.png"
                            alt="Resumen económico del centro y sus pacientes"
                        />

                        <ManualImagenPie>
                            El resumen permite comparar lo que corresponde
                            al centro, lo que ya fue pagado, lo pendiente
                            y lo que todavía está esperando el cobro del paciente.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>

                            <span>
                                Corresponde
                            </span>

                            <strong>
                                $10.000
                            </strong>

                        </ManualEjemploFila>


                        <ManualEjemploFila>

                            <span>
                                Pagado
                            </span>

                            <strong>
                                $6.000
                            </strong>

                        </ManualEjemploFila>


                        <ManualEjemploFila>

                            <span>
                                Pendiente
                            </span>

                            <strong>
                                $4.000
                            </strong>

                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualClave>
                        <strong>Esperando cobro</strong>
                        no es lo mismo que
                        <strong> Pendiente</strong>.
                        Pendiente ya corresponde al centro.
                        Esperando cobro todavía depende de
                        la condición basada en el cobro
                        del paciente.
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 13
                ====================================
                */}

                <ManualCapitulo
                    id="posicion-centro"
                >

                    <ManualCapituloNumero>
                        Capítulo 13
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo leer la Posición del centro
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Cuando seleccionás un centro aparece
                        una sección llamada
                        <strong>
                            {' '}
                            Posición de [nombre del centro]
                        </strong>.
                    </ManualTexto>


                    <ManualImportante>
                        La propia pantalla aclara que esta
                        es una
                        <strong>
                            {' '}
                            posición global, independiente
                            del período y del paciente
                            seleccionado.
                        </strong>
                    </ManualImportante>

                    <ManualImagen $ancho="grande">

                        <img
                            src="/img/tutoriales/cobros-centros/10-posicion-global-saldo-favor.png"
                            alt="Posición global del centro"
                        />

                        <ManualImagenPie>
                            La Posición del centro es global.
                            Muestra Pendiente neto, Saldo a favor
                            y Pagos sin aplicar independientemente
                            del período que estés mirando.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Pendiente neto
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra cuánto queda efectivamente
                                pendiente con el centro después
                                de considerar los movimientos
                                aplicados a su cuenta.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Saldo a favor
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra créditos disponibles
                                a favor dentro de la cuenta
                                del centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Pagos sin aplicar
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra dinero registrado
                                como pago al centro que todavía
                                no quedó imputado a una
                                obligación.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualClave>
                        Para saber
                        <strong>
                            {' '}
                            “cuánto corresponde en este mes”
                        </strong>
                        mirá el resumen del período.
                        Para saber
                        <strong>
                            {' '}
                            “cómo está la cuenta total con
                            este centro”
                        </strong>,
                        mirá la
                        <strong> Posición</strong>.
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 14
                ====================================
                */}

                <ManualCapitulo
                    id="detalle-prestaciones"
                >

                    <ManualCapituloNumero>
                        Capítulo 14
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo revisar prestaciones y mensualidades
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Una vez seleccionado el centro,
                        el detalle se agrupa por paciente.
                    </ManualTexto>


                    <ManualTexto>
                        La tabla muestra:
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Paciente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Identifica a quién corresponde
                                la información.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Condición
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Puede mostrarse como
                                General, Particular o Mixta.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Prestaciones
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Cantidad de prestaciones
                                registradas para el período.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Cobrado paciente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Importe cobrado al paciente
                                sobre las prestaciones mostradas.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Corresponde centro
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Importe que corresponde al
                                centro para ese paciente.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Pagado centro
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Importe de esas obligaciones
                                que ya fue cubierto.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Pendiente centro
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Importe que todavía se debe
                                al centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Esperando cobro
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Importe todavía condicionado
                                al cobro del paciente.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualSubtitulo>
                        Detalle de prestaciones
                    </ManualSubtitulo>


                    <ManualTexto>
                        Cuando una fila tiene prestaciones,
                        podés desplegarla para abrir
                        <strong>
                            {' '}
                            Detalle de prestaciones
                        </strong>.
                    </ManualTexto>


                    <ManualTexto>
                        Allí aparecen columnas como:
                        <strong> Fecha</strong>,
                        <strong> Vencimiento</strong>,
                        <strong> Tipo</strong>,
                        <strong> Condición</strong>,
                        <strong> Fee</strong>,
                        <strong>
                            {' '}
                            Importe prestación
                        </strong>,
                        <strong>
                            {' '}
                            Cobrado paciente
                        </strong>,
                        <strong>
                            {' '}
                            Corresponde centro
                        </strong>,
                        <strong>
                            {' '}
                            Pagado centro
                        </strong>,
                        <strong> Pendiente</strong>
                        y
                        <strong>
                            {' '}
                            Esperando cobro
                        </strong>.
                    </ManualTexto>

                    <ManualImagen $ancho="completo">

                        <img
                            src="/img/tutoriales/cobros-centros/06-detalle-prestaciones.png"
                            alt="Detalle de prestaciones de un paciente"
                        />

                        <ManualImagenPie>
                            Al desplegar un paciente podés revisar cada prestación,
                            su condición, el fee utilizado, el vencimiento,
                            lo cobrado al paciente y la situación frente al centro.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualClave>
                        En un
                        <strong>
                            {' '}
                            Importe fijo mensual
                        </strong>,
                        varias prestaciones pueden pertenecer
                        a la misma mensualidad. Por eso una
                        prestación puede aparecer como
                        <strong>
                            {' '}
                            Incluida en mensualidad
                        </strong>.
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 15
                ====================================
                */}

                <ManualCapitulo
                    id="condicion-prestacion"
                >

                    <ManualCapituloNumero>
                        Capítulo 15
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Pagar o No pagar una prestación al centro
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Puede ocurrir que una prestación
                        particular necesite una condición
                        diferente de la regla habitual.
                    </ManualTexto>


                    <ManualTexto>
                        Al abrir la
                        <strong>
                            {' '}
                            Condición de la prestación
                        </strong>,
                        la plataforma muestra primero cuál
                        es la
                        <strong>
                            {' '}
                            condición original de esa prestación
                        </strong>.
                    </ManualTexto>


                    <ManualTexto>
                        Después podés elegir:
                    </ManualTexto>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Usar condición original (Pagar / No pagar)
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                La prestación vuelve a utilizar la condición
                                que tenía originalmente. Entre paréntesis,
                                YÖGEN muestra cuál era esa condición:
                                Pagar o No pagar.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Pagar esta prestación
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Fuerza esta prestación a pagar
                                honorario al centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                No pagar esta prestación
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Fuerza esta prestación a no
                                generar honorario para el centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>

                    <ManualImagen $ancho="medio">

                        <img
                            src="/img/tutoriales/cobros-centros/13-condicion-prestacion.png"
                            alt="Condición de la prestación"
                        />

                        <ManualImagenPie>
                            Para una prestación individual podés usar
                            la condición original, forzar que pague al centro
                            o indicar que esa prestación no debe pagarse.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualImportante>
                        Esta acción modifica
                        <strong>
                            {' '}
                            la condición de pago al centro
                        </strong>.
                        No es lo mismo que marcar como
                        <strong> No cobrar</strong>
                        una prestación en la cuenta económica
                        del paciente.
                    </ManualImportante>


                    <ManualTexto>
                        Si seleccionás
                        <strong>
                            {' '}
                            Pagar esta prestación
                        </strong>
                        o
                        <strong>
                            {' '}
                            No pagar esta prestación
                        </strong>,
                        podés agregar una
                        <strong> Observación</strong>.
                    </ManualTexto>


                    <ManualTexto>
                        Al guardar el cambio, la plataforma
                        reconcilia la situación económica
                        correspondiente a esa prestación.
                    </ManualTexto>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 16
                ====================================
                */}

                <ManualCapitulo
                    id="registrar-pago"
                >

                    <ManualCapituloNumero>
                        Capítulo 16
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo registrar un pago al centro
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Cuando efectivamente realizás un pago
                        al centro, utilizá:
                        <strong>
                            {' '}
                            + Registrar pago
                        </strong>.
                    </ManualTexto>


                    <ManualTexto>
                        Se abre la pantalla
                        <strong>
                            {' '}
                            Registrar pago al centro
                        </strong>.
                    </ManualTexto>

                    <ManualImagen $ancho="grande">

                        <img
                            src="/img/tutoriales/cobros-centros/14-registrar-pago-centro.png"
                            alt="Registrar pago al centro"
                        />

                        <ManualImagenPie>
                            Antes de registrar el pago podés consultar la
                            Posición actual del centro y completar la fecha,
                            importe, medio de pago y los datos opcionales
                            de referencia, concepto y observación.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualSubtitulo>
                        Posición actual
                    </ManualSubtitulo>


                    <ManualTexto>
                        Antes de cargar el pago, el modal
                        muestra la
                        <strong>
                            {' '}
                            Posición actual
                        </strong>
                        del centro, incluyendo
                        <strong>
                            {' '}
                            Pendiente neto
                        </strong>
                        y, cuando corresponda,
                        <strong>
                            {' '}
                            Saldo a favor
                        </strong>
                        o
                        <strong>
                            {' '}
                            Pagos sin aplicar
                        </strong>.
                    </ManualTexto>


                    <ManualSubtitulo>
                        Datos del pago
                    </ManualSubtitulo>


                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Fecha de pago
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Indicá cuándo realizaste
                                efectivamente el pago.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Importe
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Cargá el dinero que efectivamente
                                pagaste al centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Medio de pago
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Podés seleccionar
                                Transferencia, Efectivo,
                                Mercado Pago u Otro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Referencia
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Campo opcional para guardar
                                una referencia externa del pago.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Concepto
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Campo opcional para identificar
                                el motivo o concepto del pago.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Observación
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Campo opcional para dejar
                                una aclaración adicional.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualPasos>

                        <ManualPaso>

                            <ManualPasoNumero>
                                1
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Seleccioná el centro.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                2
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong>
                                    {' '}
                                    + Registrar pago
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                3
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Completá
                                <strong>
                                    {' '}
                                    Fecha de pago
                                </strong>
                                e
                                <strong> Importe</strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                4
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Seleccioná el
                                <strong>
                                    {' '}
                                    Medio de pago
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                5
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Si corresponde, completá
                                <strong> Referencia</strong>,
                                <strong> Concepto</strong>
                                u
                                <strong> Observación</strong>.
                            </ManualPasoTexto>

                        </ManualPaso>


                        <ManualPaso>

                            <ManualPasoNumero>
                                6
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong>
                                    {' '}
                                    Registrar pago
                                </strong>.
                            </ManualPasoTexto>

                        </ManualPaso>

                    </ManualPasos>


                    <ManualClave>
                        El pago queda registrado contra la
                        cuenta del centro. Si parte del dinero
                        todavía no puede aplicarse a una
                        obligación, queda visible como
                        <strong>
                            {' '}
                            pago disponible / sin aplicar
                        </strong>.
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 17
                ====================================
                */}

                <ManualCapitulo
                    id="historial-pagos"
                >

                    <ManualCapituloNumero>
                        Capítulo 17
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Historial de pagos y anulaciones
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Para revisar los pagos que ya
                        registraste, utilizá
                        <strong>
                            {' '}
                            Historial de pagos
                        </strong>.
                    </ManualTexto>


                    <ManualTexto>
                        En
                        <strong> Pagos registrados</strong>
                        vas a encontrar las columnas:
                    </ManualTexto>

                    <ManualImagen $ancho="grande">

                        <img
                            src="/img/tutoriales/cobros-centros/08-historial-pagos.png"
                            alt="Historial de pagos del centro"
                        />

                        <ManualImagenPie>
                            Historial de pagos muestra el importe registrado,
                            cuánto fue imputado, cuánto permanece disponible,
                            el medio de pago, su estado y las acciones disponibles.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Fecha / detalle
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Fecha del pago y, si existen,
                                concepto o referencia.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Importe
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Total registrado en ese pago.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Imputado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Parte del pago que ya fue
                                utilizada para cubrir
                                obligaciones del centro.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Disponible
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Parte del pago que todavía
                                permanece sin aplicar.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Medio
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Medio de pago registrado.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Estado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Puede mostrar el pago como
                                Registrado o Anulado.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualSubtitulo>
                        Anular un pago
                    </ManualSubtitulo>


                    <ManualTexto>
                        Si cargaste un pago por error,
                        utilizá
                        <strong> Anular</strong>.
                    </ManualTexto>


                    <ManualTexto>
                        La plataforma abre
                        <strong> Anular pago</strong>
                        y solicita obligatoriamente un
                        <strong>
                            {' '}
                            Motivo de anulación
                        </strong>.
                    </ManualTexto>


                    <ManualAdvertencia>
                        La anulación revierte las imputaciones
                        activas del pago, pero
                        <strong>
                            {' '}
                            conserva el registro histórico.
                        </strong>
                    </ManualAdvertencia>


                    <ManualTexto>
                        Por eso un pago anulado no desaparece
                        del
                        <strong> Historial de pagos</strong>.
                        Queda visible con estado
                        <strong> Anulado</strong>
                        y con su motivo.
                    </ManualTexto>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 18
                ====================================
                */}

                <ManualCapitulo
                    id="casos-frecuentes"
                >

                    <ManualCapituloNumero>
                        Capítulo 18
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Casos frecuentes
                    </ManualCapituloTitulo>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El centro cobra un porcentaje de cada sesión.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            En
                            <strong> Tipo de fee</strong>
                            seleccioná
                            <strong> Porcentaje</strong>
                            y cargá el porcentaje acordado.
                            Después elegí cuándo se genera
                            utilizando
                            <strong>
                                {' '}
                                Cuando realizo la prestación
                            </strong>
                            o
                            <strong>
                                {' '}
                                Cuando recibo el pago del paciente
                            </strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El centro cobra un importe fijo por cada sesión.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Seleccioná
                            <strong>
                                {' '}
                                Importe fijo por prestación
                            </strong>
                            y cargá el importe correspondiente.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El centro cobra un monto mensual aunque el paciente no tenga sesiones.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Elegí
                            <strong>
                                {' '}
                                Importe fijo mensual
                            </strong>
                            y en
                            <strong>
                                {' '}
                                ¿Cuándo corresponde generar
                                el monto mensual?
                            </strong>
                            seleccioná
                            <strong>
                                {' '}
                                Si el paciente estuvo vinculado
                                al centro
                            </strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El centro cobra un monto mensual solo si el paciente tuvo prestaciones.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Elegí
                            <strong>
                                {' '}
                                Importe fijo mensual
                            </strong>
                            y
                            <strong>
                                {' '}
                                Si hubo prestaciones durante
                                el mes
                            </strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El centro cobra el mensual solo cuando hubo cobros del paciente.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Elegí
                            <strong>
                                {' '}
                                Importe fijo mensual
                            </strong>
                            y
                            <strong>
                                {' '}
                                Si hubo cobros del paciente
                                durante el mes
                            </strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            Un paciente tiene un porcentaje diferente del resto.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            En la fila del paciente utilizá
                            <strong> Configurar</strong>,
                            elegí
                            <strong>
                                {' '}
                                Condiciones particulares
                            </strong>
                            y cargá la excepción desde la
                            fecha correspondiente.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El paciente vuelve a usar las condiciones normales del centro.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            En
                            <strong>
                                {' '}
                                Condiciones del paciente
                            </strong>
                            indicá la nueva fecha y elegí
                            <strong>
                                {' '}
                                Condiciones generales
                            </strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            Una reunión en particular no debe pagarse al centro.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Abrí la
                            <strong>
                                {' '}
                                Condición de la prestación
                            </strong>
                            y seleccioná
                            <strong>
                                {' '}
                                No pagar esta prestación
                            </strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            Una prestación que normalmente no paga al centro sí debe pagarse.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Abrí la
                            <strong>
                                {' '}
                                Condición de la prestación
                            </strong>
                            y seleccioná
                            <strong>
                                {' '}
                                Pagar esta prestación
                            </strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El paciente dejó de atenderse en ese centro.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Utilizá
                            <strong>
                                {' '}
                                Finalizar vínculo
                            </strong>
                            e indicá hasta qué fecha estuvo
                            vigente la vinculación.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            Registré mal un pago al centro.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Entrá en
                            <strong>
                                {' '}
                                Historial de pagos
                            </strong>,
                            buscá el movimiento y utilizá
                            <strong> Anular</strong>.
                            Tendrás que indicar el
                            <strong>
                                {' '}
                                Motivo de anulación
                            </strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 19
                ====================================
                */}

                <ManualCapitulo
                    id="resumen-rapido"
                >

                    <ManualCapituloNumero>
                        Capítulo 19
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Resumen rápido
                    </ManualCapituloTitulo>


                    <ManualTexto>
                        Si ya conocés el sistema y solamente
                        necesitás recordar dónde hacer algo,
                        usá esta guía rápida.
                    </ManualTexto>


                    <ManualResumen>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Crear un centro
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Centros y liquidaciones →
                                <strong>
                                    {' '}
                                    + Agregar centro
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Cambiar las reglas generales
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Seleccionar centro →
                                <strong>
                                    {' '}
                                    Condiciones generales
                                </strong>
                                → crear nueva configuración.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Vincular un paciente
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Seleccionar centro →
                                <strong>
                                    {' '}
                                    Vincular paciente
                                </strong>
                                → elegir paciente →
                                indicar
                                <strong>
                                    {' '}
                                    Vigente desde
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Crear una excepción para un paciente
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Paciente →
                                <strong> Configurar</strong>
                                →
                                <strong>
                                    {' '}
                                    Condiciones particulares
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Volver a las reglas generales
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Paciente →
                                <strong> Configurar</strong>
                                →
                                <strong>
                                    {' '}
                                    Condiciones generales
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Finalizar la relación con el centro
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Paciente →
                                <strong>
                                    {' '}
                                    Finalizar vínculo
                                </strong>
                                → indicar fecha final.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Cambiar una prestación individual
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Abrir condición de la prestación →
                                <strong>
                                    {' '}
                                    Usar condición original
                                </strong>,
                                <strong>
                                    {' '}
                                    Pagar esta prestación
                                </strong>
                                o
                                <strong>
                                    {' '}
                                    No pagar esta prestación
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Saber cuánto debo hoy al centro
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Revisar
                                <strong>
                                    {' '}
                                    Posición de [centro]
                                </strong>
                                →
                                <strong>
                                    {' '}
                                    Pendiente neto
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Registrar dinero pagado al centro
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Seleccionar centro →
                                <strong>
                                    {' '}
                                    + Registrar pago
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Revisar pagos anteriores
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Seleccionar centro →
                                <strong>
                                    {' '}
                                    Historial de pagos
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Corregir un pago al centro
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Historial de pagos →
                                <strong> Anular</strong>
                                → completar
                                <strong>
                                    {' '}
                                    Motivo de anulación
                                </strong>
                                → registrar nuevamente el
                                pago correcto.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                    </ManualResumen>


                    <ManualClave>
                        <strong>Para recordar:</strong>
                        {' '}
                        primero definís las reglas del centro,
                        después vinculás los pacientes,
                        YÖGEN calcula lo que corresponde
                        según esas reglas y finalmente
                        registrás los pagos que efectivamente
                        realizás al centro.
                    </ManualClave>


                    {renderVolverIndice()}

                </ManualCapitulo>


            </ManualMain>

        </Cuerpo>

    );

};


export default ManualCobrosCentros;